<div
  class="space-x-3 bg-project-600 rounded-t-md text-project-2400"
  *ngIf="isMainMedia"
>
  <h3
    class="mat-expansion-panel-header text-sm text-inherit h-[43px] flex items-center py-0 px-6"
  >
    {{ mainMediaLabel }}
  </h3>
</div>
<div
  class="flex flex-col px-4 py-2 bg-white border divide-y rounded border-project-600 divide-project-600"
  *ngIf="sectionImgsFormControl || sectionVideosFormControl"
>
  <app-media-adder-item
    *ngIf="sectionImgsFormControl"
    [sectionFormControl]="sectionImgsFormControl"
    [mediaType]="MEDIA_TYPES.IMAGE"
    [cssIconClass]="'icon-image'"
    [addMediaLabel]="addMediaLabel"
    [isMainMedia]="isMainMedia"
    [isSlide]="isSlide"
    [isDisabled]="isDisabled"
    (handleInsertMedia)="
      INSERT_MEDIA_TYPE_HANDLERS[MEDIA_TYPES.IMAGE].emit($event)
    "
    (handleRemoveMedia)="REMOVE_MEDIA_TYPE_HANDLERS[MEDIA_TYPES.IMAGE]($event)"
    (handleAddMedia)="onAddMedia($event)"
  >
    <ng-template let-media let-index="index">
      <div class="flex w-full space-x-4">
        <div class="h-20 bg-project-600">
          <img
            class="object-contain h-full w-36"
            [src]="media.thumbnailUrl"
            [alt]="media.name"
            title="{{ media.name }}"
            data-testid="media-adder-img"
          />
        </div>
        <div class="flex flex-col flex-1">
          <mat-form-field
            *ngIf="showCaption"
            class="w-full -mt-3 text-project-50"
            [appearance]="'outline'"
          >
            <input
              type="text"
              matInput
              [value]="media.caption"
              (change)="changeCaption($event.target.value, index)"
              placeholder="Caption"
              class="text-project-1400"
              [disabled]="isDisabled"
              data-testid="media-adder-caption"
            />
            <button
              *ngIf="media.caption && !isDisabled"
              matSuffix
              mat-flat-button
              aria-label="Clear"
              (click)="media.caption = ''"
              class="w-6 min-w-0 px-0 text-project-1100"
              data-testid="media-adder-clear-caption-btn"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="isMainMedia && displayImageOnWebsiteControl">
            <mat-checkbox
              class="hover:text-project-2100 hover:underline"
              color="primary"
              [formControl]="displayImageOnWebsiteControl"
              data-testid="checkbox-list-item"
            >
              Show main image on websites
            </mat-checkbox>
          </div>
        </div>
      </div>
    </ng-template>
  </app-media-adder-item>

  <app-media-adder-item
    *ngIf="sectionVideosFormControl"
    [sectionFormControl]="sectionVideosFormControl"
    [mediaType]="MEDIA_TYPES.VIDEO"
    [cssIconClass]="'icon-youtube-play'"
    [isMainMedia]="isMainMedia"
    [addMediaLabel]="addMediaLabel"
    [isDisabled]="isDisabled"
    (handleInsertMedia)="
      INSERT_MEDIA_TYPE_HANDLERS[MEDIA_TYPES.VIDEO].emit($event)
    "
    (handleRemoveMedia)="REMOVE_MEDIA_TYPE_HANDLERS[MEDIA_TYPES.VIDEO]($event)"
    (handleAddMedia)="onAddMedia($event)"
  >
    <ng-template let-media>
      <a
        href="#"
        (click)="onPlayMediaVideo($event, media)"
        class="relative flex flex-col h-full w-36 bg-dark group"
        data-testid="media-adder-play-video-btn"
      >
        <i
          class="text-white opacity-0 icon icon-play group-hover:cursor-pointer group-hover:opacity-100 absolute top-[25%] z-10 text-4xl left-[40%]"
        ></i>
        <img
          class="object-contain w-auto h-full"
          [src]="media.thumbnailUrl"
          [alt]="media.thumbnailUrl"
        />
      </a>
    </ng-template>
  </app-media-adder-item>
</div>
